import { getIsCpCoreEnabled } from "Teacher/routes/Projects/modules/Utils";
import { getIsIBISAnticipatedCategoryEnabled } from "./ACLStoreUtils";
import _ from "lodash";
import {
  CATEGORY_ANTICIPATED,
  CATEGORY_CAREER_RELATED_CERTIFICATE,
  CATEGORY_COURSE,
  CATEGORY_DIPLOMA,
  CATEGORY_OTHERS,
} from "Constants/stringConstants";

export const getRegistrationCategoryOptions = ({
  t = () => {},
  includeNotAssigned = false,
  includeAll = false,
  includeOthers = true,
  includeCareerRelatedCertificate = true,
}) => {
  const options = [
    {
      id: null,
      key: null,
      label: t("common:not_assigned"),
      value: null,
      isVisible: includeNotAssigned,
    },
    {
      id: "ALL",
      key: "ALL",
      label: t("common:all"),
      value: "ALL",
      isVisible: includeAll,
    },
    {
      id: "DIPLOMA",
      key: "DIPLOMA",
      label: t("common:diploma"),
      value: "DIPLOMA",
      isVisible: true,
    },
    {
      id: "COURSE",
      key: "COURSE",
      label: t("common:dp_course"),
      value: "COURSE",
      isVisible: true,
    },
    {
      id: "ANTICIPATED",
      key: "ANTICIPATED",
      label: t("common:anticipated"),
      value: "ANTICIPATED",
      isVisible: getIsIBISAnticipatedCategoryEnabled(),
    },
    {
      id: "CAREER_RELATED_CERTIFICATE",
      key: "CAREER_RELATED_CERTIFICATE",
      label: t("common:career_related_certificate"),
      value: "CAREER_RELATED_CERTIFICATE",
      isVisible: includeCareerRelatedCertificate && getIsCpCoreEnabled(),
    },
    {
      id: "OTHERS",
      key: "OTHERS",
      label: t("common:others"),
      value: "OTHERS",
      isVisible: includeOthers,
    },
  ];

  return _.filter(options, option => option.isVisible);
};

export const EXAM_REGISTRATION_CATEGORIES_LABEL = {
  DIPLOMA: "common:diploma",
  COURSE: "common:dp_course",
  OTHERS: "common:others",
  ANTICIPATED: "common:anticipated",
  CAREER_RELATED_CERTIFICATE: "common:career_related_certificate",
};

export const getRegistrationCategoryFilterOptionsMemoized = _.memoize(
  getRegistrationCategoryOptions,
  ({ includeNotAssigned = false, includeAll = false, t }) => {
    const isAnticipatedEnabled = getIsIBISAnticipatedCategoryEnabled();
    const isCareerRelatedCertificateEnabled = getIsCpCoreEnabled();
    const isTArgumentPresent = typeof t === "function";

    return `includeNotAssigned:${includeNotAssigned}-includeAll:${includeAll}-isAnticipatedEnabled:${isAnticipatedEnabled}-isCareerRelatedCertificateEnabled:${isCareerRelatedCertificateEnabled}-isTArgumentPresent:${isTArgumentPresent}`;
  }
);

export const REGISTRATION_CATEGORIES = [
  null,
  CATEGORY_DIPLOMA,
  CATEGORY_COURSE,
  CATEGORY_ANTICIPATED,
  CATEGORY_OTHERS,
  CATEGORY_CAREER_RELATED_CERTIFICATE,
];
